import {
  PROJECT_BUILD_INFO_SUCCESS,
  CONSTRUCTION_RESULT,
  CONSTRUCTION_ID_PROJECTS,
  CONSTRUCTION_SENDER,
} from "Stores/actionTypes";
import { updateObject } from "./utility";

const initialState = {
  constructionData: [],
  constructionPagination: { Limit: 5, Page: 1, Total: 0 },
  constructionSender: null,
  constructionResult: {
    isFrame: false,
    isSash: false,
    isSashDoor: false,
    isMulion: false,
    isGlazing: false,
    isRokob: false,
    isInterLock: false,
    isConectorSash: false,
    isOtherRail: false,
    isOtherPop: false,
    isPanel: false,
    isProfileKomaki: false,
    isGlass: false,
    isNet: false,
    isFitting: false,
    isProfile: false,
    isOther: false,
    lenBranch: 6000,
    CheckAll: false,
    isBeforeOptimal: false,
    ListUnitId: [],
  },
  idProjects: [],
  additionalIdProjects: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CONSTRUCTION_SENDER:
      return updateObject(state, {
        constructionSender: action.constructionSender,
      });
    case PROJECT_BUILD_INFO_SUCCESS:
      return updateObject(state, {
        constructionData: action.constructionData,
        constructionPagination: action.constructionPagination,
      });
    case CONSTRUCTION_ID_PROJECTS:
      return updateObject(state, {
        idProjects: action.idProjects,
        additionalIdProjects: action.idProjects,
      });
    case CONSTRUCTION_RESULT:
      return updateObject(state, {
        constructionResult: action.constructionResult,
      });
    default:
      return state;
  }
};

export default reducer;
